import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { environment } from '../../../environments/environment';
import { HttpService } from '../../shared/services/http.service';
import { HelperService } from '../../shared/services/helper.service';
import { SidebarService } from '../../shared/services/sidebar.service';
import { ToastService } from '../../shared/services/toast.service';

@Component({
  selector: 'app-raised-to-me',
  templateUrl: './raised-to-me.component.html',
  styleUrl: './raised-to-me.component.css',
})
export class RaisedToMeComponent implements OnInit {
  @Input() raiseToMeList: any = {};
  @Input() isDependeciesLoading: boolean = false;
  discussModal: boolean = false;
  acceptModal: boolean = false;
  user_Id: string = '';
  httpService = inject(HttpService);
  messageService = inject(MessageService);
  sidebarService = inject(SidebarService);
  toastService=inject(ToastService);
  helper = inject(HelperService);
  delegateDependency: boolean = false;
  membersLists: any = [];
  selectedMember: any = null;
  groupMemberList: any;
  selectedGroup: any;
  overAllGroupData: any;
  selectedGroupMember: any;
  @Output() updateDelegateState= new EventEmitter<any>();
  
  onDelegate() {
    this.selectedGroupMember = null;
    this.selectedGroup=null
    this.delegateDependency = true;
  }
  isDiscuss: boolean = false;

  ngOnInit() {
    // this.fetchMemeberLists();
    this.onOverAllSearchChange();

  }
  onDiscuss() {
    this.discussModal = true;
  }

  onAccept() {
    this.acceptModal = true;
  }

  
  onOverAllSearchChange(event?: any) {
    const currentSelection: any = this.selectedGroup;

    this.httpService
      .post(`${environment.opbBackendHost}/api/member/all/groups`, {
        search: event?.filter,
      })
      .subscribe(
        (response) => {
          this.overAllGroupData = response?.data;

          if (
            currentSelection &&
            !this.overAllGroupData?.find(
              (item: any) => item?.name === currentSelection?.name
            )
          ) {
            this.overAllGroupData.push(currentSelection);
          }
        },
        (error) => {
          console.error('API Error:', error);
        }
      );
  }

  reAssign() {
    let data = {
      dependency_id: this.raiseToMeList?.dependency_id,
      new_user_id: '352',
    };
    this.httpService
      .post(
        `${environment.opbBackendHost}/api/member/dependencies/reassign`,
        data
      )
      .subscribe((res: any) => {
        if (res?.code == 200) {
          this.messageService.add({
            severity: 'success',
            summary: res?.message,
          });
          this.raiseToMeList.status = 6;
        }
      });
  }

  onGroupDataChange(searchTerm?: any): void {
    this.selectedGroupMember = null;
    const currentSelection: any = this.selectedGroupMember;
    const requestData = {
      groups: this.selectedGroup?.group_id,
      search: searchTerm || '',
    };
    this.httpService.post(`${environment.opbBackendHost}/api/member/group/members`, requestData).subscribe(
      (response) => {
        this.groupMemberList = response?.data || response;

        // Filter out logged-in user and update the list
        this.groupMemberList = this.groupMemberList.filter(
          (m: any) =>
            m?.user_id !== this.raiseToMeList.creator?.user_id &&
            m?.user_id !== this.raiseToMeList.user?.user_id
        );
        if (
          currentSelection &&
          !this.groupMemberList?.find(
            (item: any) => item?.name == currentSelection?.name
          )
        ) {
          this.groupMemberList.push(currentSelection);
        }
      },
      (error) => {
        console.error('API Error:', error);
      }
    );
  }

  onTeamSearch(event: any): void {
    const searchTerm = event.filter;
    const url = `${environment.opbBackendHost}/api/member/group/members`;

    this.sidebarService.performSearch(url, { search: searchTerm }).subscribe({
      next: (res: any) => {
        this.groupMemberList = res
        this.groupMemberList = this.groupMemberList.filter(
          (m: any) =>
            m?.user_id !== this.raiseToMeList.creator?.user_id &&
            m?.user_id !== this.raiseToMeList.user?.user_id
        );
      },
      error: (err: any) => {
        console.error('Error fetching data:', err);
      },
    });
  }

  triggerDiscussion() {
    let data = {
      dependency_id: this.raiseToMeList?.dependency_id,
    };
    this.acceptModal = false;
    this.httpService
      .post(
        `${environment.opbBackendHost}/api/member/dependencies/accept`,
        data
      )
      .subscribe((res: any) => {
        if (res?.code == 200) {
          this.messageService.add({
            severity: 'success',
            summary: res?.message,
          });
          this.raiseToMeList.status = 1;
        }
      });
  }

  closeDiscussion() {
    this.discussModal = false;
  }

  triggerAccept() {
    let data = {
      dependency_id: this.raiseToMeList?.dependency_id,
    };
    this.isDiscuss = true;
    this.httpService
      .post(
        `${environment.opbBackendHost}/api/member/dependencies/discuss`,
        data
      )
      .subscribe((res: any) => {
        if (res?.code == 200) {
          this.messageService.add({
            severity: 'success',
            summary: res?.message,
          });
          this.raiseToMeList.status = 6;
        }
        this.closeAccept();
      });
  }

  closeAccept() {
    this.discussModal = false;
  }

  onDropdownChange(event: any): void {
    this.user_Id = event?.value?.user_id;
  }
  fetchMemeberLists() {
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/group/members`, {})
      .subscribe((res: any) => {
        if (res?.code == 200) {
        }
        this.membersLists = res?.data;
      });
  }

  delegate() {
    let data = {
      dependency_id: this.raiseToMeList?.dependency_id,
      delegate_to: this.selectedGroupMember?.user_id,
    };
    this.httpService
      .post(
        `${environment.opbBackendHost}/api/member/dependencies/delegate`,
        data
      )
      .subscribe((res: any) => {
        res?.error
            ? this.toastService.error(res?.message)
            : this.toastService.success(res?.message);
          this.updateDelegateState.emit(res?.data)
          this.raiseToMeList.status = 0;
          this.delegateDependency = false;
              
        });
  }

  closeDelegate() {
    this.delegateDependency = false;
  }
}
